import styled from 'styled-components';

const StyledContainer = styled.div``;

export default StyledContainer;

export const Container = styled.div`
    padding: 20px;
`;

export const TableWrapper = styled.div`
    padding: 20px;
    border-radius: 8px;
    background-color: #ffffff;
`;